<template>
    <div id="app" v-touch:right="onSwipeLeft">
        <router-view />
        <!-- <div class="download_box" v-if="is_show_footer && app.is_disable === 'Y' && is_show_down_app">
     <a :href="app.app_link" class="down">
         <div class="down_left">
             <span class="app_logo" v-bind:style="{'background-image':'url(' + app.image + ')'}"></span>
             <div class="app_info">
                 {{app.text1}}<br>{{app.text2}}
             </div>
         </div>
         <div class="right">App</div>
     </a>
     <span class="close_down" @click="closeDownApp"></span>
 </div> -->
        <div v-if="is_show_footer" class="footer">
            <router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_home" />
                <p class="footer_info">
                    Jogos
                </p>
            </router-link>

            <router-link to="/myteam" class="footer_item" :class="show_icon_type === 'share' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_cart" />
                <p class="footer_info">
                    Share
                </p>
            </router-link>

            <router-link to="/invest" class="footer_item" :class="show_icon_type === 'invest' ? 'footer_item_active' : ''">
                <div class="tabbar-item-cz-lbsA7"><img class="tabbar-item-gif-wXsFN"
                        src="data:image/gif;base64,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"
                        alt="">
                    <section class="tabbar-item-text-ubXYy tabbar-item-cz-text-qstJE">Depósito</section>
                </div>
            </router-link>
            <router-link to="/item" class="footer_item" :class="show_icon_type === 'item' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_task" />
                <p class="footer_info">
                    Atividade
                </p>
            </router-link>

            <router-link to="/reward" class="footer_item" :class="show_icon_type === 'reward' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_user" />
                <p class="footer_info">
                    Bônus
                </p>
            </router-link>
        </div>
       
    </div>
</template>

<script>
import {
    Dialog
} from 'vant';
import Fetch from "./utils/fetch";
import axios from 'axios'
import api from "./interface/index"
export default {
    name: 'App',
    data() {
        return {
            show_icon_type: 'index',
            real_name: false,
            is_show_down_app: true,
            is_show_footer: true,
            sync_timer: null,
            app: {},
        }
    },
    updated() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    },
    mounted() {



        this.start();
    },
    methods: {
        onSwipeLeft(even, start, end) {
            //console.log(window.location.href);

            if (window.location.href.indexOf('signature')) {
                return false;
            }
            if (end['X'] - start['X'] > 60) {
                this.$router.go(-1);
            }
        },
        bigNumeber(str) {
            var str = str.toString();
            var strs = str.split(".");
            var s1 = strs[0] || 0;
            var s2 = strs[1] || "00"
            return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
        },
        numFilter(value) {
            let transformVal = parseFloat(value).toFixed(3)
            let realVal = transformVal.substring(0, transformVal.length - 1)
            return parseFloat(realVal)
        },
        footer: function (type = 'index', show_footer = true) {
            if (type == 'walfare') {
                document.getElementById('app').style.paddingBottom = '0';
            } else {
                document.getElementById('app').style.paddingBottom = '1.333333rem';
            }
            this.show_icon_type = type;
            this.is_show_footer = show_footer;
        },
        start() {
            // this.sync_timer = setInterval(() => {
            //     this.sync()
            // }, 3000);
        },
        closeDownApp() {
            this.is_show_down_app = false;
        },
        sync() {
            /* Fetch("/index/sync", {}, null, false).then((r) => {
                 if (r.data.is_open_notice_dialog) {
                     this.openNoticeDialog();
                 }
             }); */
        },
        close() {
            this.show_anwser = false;
        },
        openNoticeDialog() {
           
        },
    }
}
</script>
<style lang="less">
// @import "./assets/font/font.css";
.tabbar-item-cz-text-qstJE {
    font-size: 0.3rem;
    font-weight: 700;
   
    animation: tabBarBlink-BwOOG 1.5s ease 0s infinite normal none running
}
.tabbar-item-gif-wXsFN {
    width: .8rem;
    height: .8rem;
    margin-bottom: .08rem
}
.tabbar-item-cz-lbsA7 {
    padding-top: .08rem;
    // background:  linear-gradient(180deg,#5a91e9,#1dd0c3);
    border: .12rem solid var(--cms-mango-background-color3);
    background:  url(./views/images/des.png) no-repeat;
    background-size: cover;
    border-radius: 50%;
    width: 1.75rem;
    height:1.75rem;
    color: #fff;
    text-align: center;
    margin-top: -.48rem
}

.logo {
    width: 114px;
    height: 24px;
    margin-left: 8px;
    margin-top: 8px;
}

.mt44 {
    margin-top: 44px;
}

.kefu {
    width: 40px;
    height: 40px;
    position: fixed;
    z-index: 10;
    right: 8px;
    bottom: 64px;
    transition: all 1s;
    opacity: 1;
    transform: translateX(0);
    z-index: 80;

    img {
        width: 40px;
        height: 40px;
    }
}

.kefu.kefu_hide {
    transform: translateX(70%);
    opacity: 0.5;
}

.numberFont {
    font-family: barlow !important;
    font-size: 15px !important;
    font-weight: bold !important;

    span:nth-of-type(3) {
        font-size: 14px !important;
    }

    span:nth-of-type(4) {
        font-size: 12px !important;
    }
}

html,
body {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    font-family: "微软雅黑" !important;
    user-select: none !important;
    ;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}

body {
    margin: 0;
}

.bigNum {
    font-size: 18px !important;
}

.fh {
    font-size: 12px !important;
}

.larfont .fh {
    margin-top: 3px;
}

.wan {
    font-size: 14px;
    margin-top: 2px;
}

.numberFontBold {
    span:first-child {
        font-size: 12px;
        margin-top: 4px;
    }

    span:last-child {
        margin-top: 2px;
    }
}

#app {
    padding-bottom: 65px !important;
    min-height: 100%;
    height: auto;
    width: 100%;
    max-width: 375px;
    //background-color: #FAFAFA;
    //background: linear-gradient(#1D2846,#3F589A);
    // background: rgb(29, 40, 70);
    background-color: #132816;
    
}

#app .download_box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 45px;
    width: 100%;
    max-width: 375px;
    background: rgba(0, 0, 0, 0.5);
    bottom: 50px;
    padding: 0 3.6%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 10;
}

#app .download_box .down {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-right: 10px;
}

#app .download_box .down .down_left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

#app .download_box .down .down_left .app_logo {
    display: inline-block;
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-image: url(./views/images/home/app_logo.svg);
    margin-right: 14px;
    ;
}

#app .download_box .down .down_left .app_info {
    font-size: 12px;
    color: #fff;
    line-height: 1.5;
    ;
}

#app .download_box .down .right {
    background: #D8232C;
    padding: 5px 5px;
    color: #ffffff;
    border-radius: 5px;
    font-size: 12px;
}

#app .download_box .close_down {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20px;
    flex: 0 0 20px;
    height: 45px;
    ;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-image: url(./views/images/home/close.svg);
}

#app .footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 415px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 48px;
    flex: 0 0 48px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: #18213A;
    background: #287537;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    bottom: 0;
    height: 60px;
    z-index: 9999;
}

#app .footer .footer_item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    cursor: pointer;
    color: #999999;
    width: 60px;
}

#app .footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#app .footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(./views/images/nav/nav01_h.png);
}

#app .footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(./views/images/nav/nav02_h.png);
}

#app .footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(./views/images/nav/nav03_h.png);
}

#app .footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(./views/images/home/reward.png);
}

#app .footer .footer_item .footer_info {
    font-size: 12px;
    color: #999;
}

#app .footer .footer_item.footer_item_active .footer_info {
    color: #fff !important;
    font-weight: 700;
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
    background-image: url(./views/images/nav/nav01.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_task {
    background-image: url(./views/images/nav/nav02.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_cart {
    background-image: url(./views/images/nav/nav03.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
    background-image: url(./views/images/home/reward2.png);
}

.red_top_bg {
    width: 100%;
    max-width: 415px;
    height: 44px;
    margin: 0 auto;
    //background: #FFF;
    background-size: 100% 100%;
    overflow: hidden;
}

.top_right {
    position: absolute;
    font-size: 13px;
    line-height: 18px;
    color: #FFFFFF;
    top: 16px;
    right: 14px;
}

.limit {
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    background: rgba(241, 34, 17, 0.08);
    color: #f12211;
    text-align: center;
    padding: 0 7px;
    border: 1px solid #f12211;
    font-size: 12px;
}

.gray_btn {
    height: 20px;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    border-radius: 10px;
    padding: 0 9px;
}


.sub_btn {
    background: linear-gradient(123deg, #e3382e, #ff4d15);
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    width: 94px;
    border-radius: 18px;
}

.remove_btn {
    background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    width: 94px;
    border-radius: 18px;
}

.home_tit {
    width: 100%;
    height: 22px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    .line {
        width: 75px;
        height: 2px;
    }

    h5 {
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin: 0 10px;
        font-weight: bold;
    }
}

.van-popup {
    max-width: 100%;
    margin: 0 auto;
    right: 0;
}

.back_left {
    //width: 20px;
    //height: 20px;
    height: 100%;
    width: 30px;
    //background: url(./views/images/item/back.png) no-repeat center center;
    background-size: 25px 25px;
    //margin: 12px 0 0 8px;
}

.basic_btn {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
    border-radius: 23px;
    color: #FFFFFF;
    text-align: center;
}

.basic_btn.no_touch {
    color: rgba(255, 255, 255, 0.5);
}

.flex_center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wrap_box {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 6px;
}

.eye_bi {
    width: 21px;
    height: 25px;
    background: url(./views/images/user/eye3.png) no-repeat center center;
    background-size: 100% auto;

    &.eye {
        background: url(./views/images/user/eye1.png) no-repeat center center;
        background-size: 100% auto;
    }
}

.real_name_mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    background-color: rgba(0, 0, 0, 0.95);

    .real_box {
        width: 272px;
        height: 185px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin: -92px auto 0 auto;

        .tit {
            width: 77px;
            height: 67px;
            position: absolute;
            top: -35px;
            left: 50%;
            transform: translateX(-50%);
            background: url(./views/images/user/tit.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .tips {
            width: 185px;
            height: 50px;
            text-align: center;
            font-size: 18px;
            color: #000000;
            line-height: 25px;
            position: absolute;
            top: 49px;
            left: 50%;
            transform: translateX(-50%);
        }

        .basic_btn {
            width: 225px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: 15px;
        }
    }
}

.contract_box img {
    width: 100%;
}</style>
